import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between q-py-lg section-container background-gray" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-grow flex items-center" }
const _hoisted_6 = { class: "additional-text q-mr-sm" }
const _hoisted_7 = {
  class: "col",
  style: {"max-width":"130px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 q-mb-md" }
const _hoisted_11 = { class: "additional-text" }
const _hoisted_12 = { class: "text-weight-bold" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "additional-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_CreateTicketDialog = _resolveComponent("CreateTicketDialog")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('support')), 1),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          "icon-right": "add",
          class: "q-btn__main-size text-weight-bold",
          label: _ctx.$t('create_ticket'),
          unelevated: "",
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateTicketDialog = !_ctx.showCreateTicketDialog))
        }, null, 8, ["label"])
      ]),
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
        "inline-label": "",
        breakpoint: 0,
        align: "justify",
        class: "q-mb-md section-container q-pt-lg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: _ctx.campaignStatusOptions[0].value,
            label: _ctx.campaignStatusOptions[0].label
          }, null, 8, ["name", "label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: _ctx.campaignStatusOptions[1].value,
            label: _ctx.campaignStatusOptions[1].label
          }, null, 8, ["name", "label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_table, {
          rows: _ctx.rows,
          columns: _ctx.columns,
          "row-key": "id",
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
          loading: _ctx.loading,
          onRequest: _ctx.onRequest,
          onRowClick: _ctx.onRowClick,
          "binary-state-sort": "",
          flat: "",
          "rows-per-page-label": _ctx.$t('rows_per_page'),
          grid: _ctx.$q.screen.width <= 1199
        }, _createSlots({
          "body-cell-status": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getTicketStatusName(props.row.status)), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-actions": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  label: "Open ticket",
                  "icon-right": _ctx.heroOutline24ArrowLongRight,
                  color: "gray",
                  unelevated: "",
                  outline: "",
                  class: "q-btn__main-size text-weight-bold",
                  "no-caps": ""
                }, null, 8, ["icon-right"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, [
          (_ctx.$q.screen.width <= 1199)
            ? {
                name: "item",
                fn: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('date')) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.format(props.row.createdAt)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_q_btn, {
                          label: "Open ticket",
                          "icon-right": _ctx.heroOutline24ArrowLongRight,
                          to: 'tickets/' + props.row.id,
                          color: "gray",
                          unelevated: "",
                          outline: "",
                          class: "q-btn__main-size text-weight-bold",
                          "no-caps": ""
                        }, null, 8, ["icon-right", "to"])
                      ])
                    ]),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('theme')) + ":", 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(props.row.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('status')) + ":", 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.getTicketStatusName(props.row.status)), 1)
                      ])
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "onRowClick", "rows-per-page-label", "grid"])
      ]),
      (_ctx.showCreateTicketDialog)
        ? (_openBlock(), _createBlock(_component_CreateTicketDialog, {
            key: 0,
            open: _ctx.showCreateTicketDialog,
            onClose: _ctx.onCloseDialog,
            onRefresh: _ctx.onRequest
          }, null, 8, ["open", "onClose", "onRefresh"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}